import React from 'react'
import { Link } from 'react-router-dom'
import { string, func } from 'prop-types'
import { translate } from 'react-i18next'
import { PagesPaths } from '../../constants/Pages'

const UnauthenticatedUI = ({
    closeMenu,
    activePage,
    t
}) => (
  <ul className='nav__list'>
    <span className='nav__flex'>
      <li className={'nav__item ' + (activePage === PagesPaths.SIGNIN.name ? 'active' : '')}>
        <Link onClick={closeMenu} className='nav__link' to='/connexion'>{t('nav:signin')}</Link>
      </li>
    </span>
  </ul>
)

UnauthenticatedUI.propTypes = {
  closeMenu: func,
  activePage: string,
  t: func
}

export const Unauthenticated = translate()(UnauthenticatedUI)



// WEBPACK FOOTER //
// ./src/components/header/Unauthenticated.js